// extracted by mini-css-extract-plugin
export default {"dropDownMenu":"AccountMenu_dropDownMenu__1yxHe","settings":"AccountMenu_settings__leI9h","displayName":"AccountMenu_displayName__aPk+R"};